import { Alert, Typography } from "@mui/material";
import type { FC } from "react";
import { config } from "../../../../../config";

export const NoCustomDomainsMessage: FC = () => {
  return (
    <Alert severity="warning" sx={{ mt: 2 }}>
      <Typography variant="body2">
        {`You do not have any custom domains configured. By default all emails will be sent from '${config.defaultEmailFrom}'`}
      </Typography>
    </Alert>
  );
};
